import { Container, Card } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './Licenses.css';

export interface LicensesProps {
  licenses: AboutContentDto['licenses'];
}

export function Licenses({ licenses }: LicensesProps) {
  if (licenses.length === 0) {
    return null;
  }
  return (
    <section className="dma-licenses" aria-labelledby="dma-licenses-heading">
      <Container>
        <h2 id="dma-licenses-heading">مجوزها و صلاحیت‌ها</h2>
        <div className="dma-licenses__grid">
          {licenses.map((license) => (
            <Card key={license.title} className="dma-licenses__item">
              <h3 className="dma-licenses__title">{license.title}</h3>
              <p className="dma-licenses__description">{license.description}</p>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}
